import { useState, useCallback, useEffect } from 'react';
import { message } from 'antd';
import p201Api, { FP210 } from '../../../services/p201Api';

export function useP201Navigation() {
  const [list, setList] = useState<FP210[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [keyword, setKeyword] = useState('');
  const [currentIndex, setCurrentIndex] = useState(-1);

  const fetchList = useCallback(async (p = 1, kw = '') => {
    try {
      const res = await p201Api.list(p, 20, kw);
      setList(res.data || []);
      setTotal(res.total);
      setPage(p);
      return res.data || [];
    } catch {
      message.error('載入列表失敗');
      return [];
    }
  }, []);

  useEffect(() => {
    fetchList(1, keyword);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const search = useCallback(async (kw: string) => {
    setKeyword(kw);
    const data = await fetchList(1, kw);
    return data;
  }, [fetchList]);

  const goFirst = useCallback(() => {
    if (list.length > 0) {
      setCurrentIndex(0);
      return list[0].fp210_01;
    }
    return null;
  }, [list]);

  const goLast = useCallback(() => {
    if (list.length > 0) {
      setCurrentIndex(list.length - 1);
      return list[list.length - 1].fp210_01;
    }
    return null;
  }, [list]);

  const goPrev = useCallback(() => {
    if (currentIndex > 0) {
      const idx = currentIndex - 1;
      setCurrentIndex(idx);
      return list[idx].fp210_01;
    }
    return null;
  }, [currentIndex, list]);

  const goNext = useCallback(() => {
    if (currentIndex < list.length - 1) {
      const idx = currentIndex + 1;
      setCurrentIndex(idx);
      return list[idx].fp210_01;
    }
    return null;
  }, [currentIndex, list]);

  const setCurrentById = useCallback((id: string) => {
    const idx = list.findIndex(r => r.fp210_01 === id);
    if (idx >= 0) setCurrentIndex(idx);
  }, [list]);

  return {
    list, total, page, keyword, currentIndex,
    fetchList, search, goFirst, goLast, goPrev, goNext, setCurrentById,
    hasPrev: currentIndex > 0,
    hasNext: currentIndex < list.length - 1,
  };
}
